import { date } from "faker";
import React, { useState, useEffect } from "react";
import axios from "../../helpers/axios";

const usePartStatusDuration = (props) => {
  const { range, status } = props;

  const [duration, setDuration] = useState(0);
  const [isLoading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);

    let date = props.range.value
    date = date.split("-");
    
    const year = date[0];
    const month = Number(date[1]) + 1;
    const status = props.status.id;

    axios
      .get(`/api/dashboard/part_status/?part_status=${status}&year=${year}&month=${month}`)
      .then(response => {
        setDuration(response.data[0].average);
      })
      .catch(error => {
        console.error(error);
      })
      .then(() => {
        setLoading(false);
      });

  }, [range, status]);

  return { range, status, isLoading, duration };
};

const PartStatusDuration = (props) => {
  const { status, isLoading, duration } = usePartStatusDuration(props);

  return (
    <div className="card">
      <div className="card-content">
        <h1 className="title is-6 has-text-centered">{status.label}</h1>
        {isLoading ? (
          <div className="hero">
            <div className="hero-body">
              <h1 className="title is-5 has-text-centered has-text-info">
                Cargando
              </h1>
            </div>
          </div>
        ) : (
          <div className="hero">
            <div className="hero-body">
              <h1 className="title is-5 has-text-centered has-text-info">
                {Math.floor(duration / (24 * 3600))} días &nbsp;
                {Math.floor(duration / 3600) % 24} horas
              </h1>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PartStatusDuration;
